import { render } from "./Col12.vue?vue&type=template&id=262bc9c8"
import script from "./Col12.vue?vue&type=script&lang=js"
export * from "./Col12.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__